// src/data/education.js

export const educationData = [
  {
    src: '/education_images/exchange.jpg',
    title: 'Exchange Program (2023)',
    bullets: [
      'Exchange at the School of Computer Science at The University of Birmingham (Jan–Jun 2023)',
      'Modules: Artificial Intelligence, Internet of Things, Computer Vision & Imaging',
    ],
  },
  {
    src: '/education_images/TA.jpg',
    title: 'Teaching Assistant (2022–2023)',
    bullets: [
      'TA for CG1111A: Engineering Principles and Practices I (Aug–Nov 2022)',
      'Assisted labs: circuit construction & sensor integration',
      'Supervised final projects—autonomous robotic-vehicle maze navigation',
      'Graded lab reports with detailed feedback',
    ],
  },
  {
    src: '/education_images/Connecto.png',
    title: 'Project Director of Connecto at NUS MedTech (2023–2024)',
    bullets: [
      'Led interdisciplinary team to build a smart IoT home system for Muscular Dystrophy patients',
      'Collaborated with Microtube Technologies (startup)',
      '4th place at NUS Medical Grand Challenge 2024',
    ],
  },
  {
    src: '/education_images/nus.jpg',
    title: 'Bachelor of Engineering (Honours) from NUS (2020–2024)',
    bullets: [
      'Double major in Computer Engineering and Innovation & Design',
      'Societies: Guitar Ensemble, Stage, MedTech Society, IdP Students\' Club, Naach, Indian Cultural Society, Tamil Language Society,',
      'Modules: Data Structures & Algorithms, Software Engineering & OOP, ML, AI, UI/UX Design',
    ],
  },
  {
    src: '/education_images/ambassador.jpg',
    title: 'Alumni Ambassador 2024 for School of Electrical and Computer Engineering (ECE)',
    bullets: [
      'Representing ECE Dept in alumni-student networking events',
      'Organizing reunion events and networking sessions',
      'Fostering engagement between current students and alumni',
    ],
  },
];
